import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const SMRStatus = ({
  control,
  name,
  onSelectChange,
  target,
  excludeValues = [],
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [countriesData, setCountriesData] = useState([])

  const loadOptions = async () => {
    const allOptions = [
      { label: "Draft", value: 1 },
      { label: "Shared", value: 3 },
    ]

    const filtered = allOptions
      .filter(opt => !excludeValues.includes(opt.value))
      .map(opt => ({
        ...opt,
        label: ucfirst(opt.label),
      }))

    setCountriesData(filtered)
    setIsLoading(false)
  }

  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={countriesData}
              placeholder={"Status"}
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector(
                target ? target : "body"
              )}
            />
          )
        }}
      />
    </div>
  )
}

export default SMRStatus
